import carousel from './carouselData';
import services from './servicesData';

export default {
    carousel,
    services
}


// WEBPACK FOOTER //
// ./src/data/initialState.js